import { Fetcher } from '@this/src/util';
import type { PaymentMethod, PaymentGateway } from '../types/payment';

type ArrangementResponse = {
  success: boolean;
  order_id?: number;
  error?: string;
};

export type ArrangementResult = {
  success: boolean;
  orderId?: number;
  error?: string;
};

const convertResponse = (response: ArrangementResponse): ArrangementResult => ({
  success: response.success,
  orderId: response.order_id,
  error: response.error
});

export type ArrangementPaymentParams = {
  payment_method?: PaymentMethod;
  payment_gateway_type?: PaymentGateway;
  token?: string;
  card_seq?: string;
  payment_transaction?: { uid: string };
};

export const createArrangement = async (
  tripId: string,
  payment: ArrangementPaymentParams = {}
): Promise<ArrangementResult> => {
  const response = await Fetcher.post<ArrangementResponse>(`/trips/${tripId}/ai_arrangements`, payment);
  return convertResponse(response);
};
